module.exports = __webpack_public_path__ + "static/img/like_1_1.61c0fe03.svg";